module.exports = __webpack_public_path__ + "static/img/06-points-box-4-points.a954303.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-assignment-guide/06-points-box-4-points.png
// module id = kIvC
// module chunks = 1